import React from "react";
import Select from "react-select";
import { City } from "country-state-city";

const CityDropdown = ({
  selectedCountry,
  selectedState,
  selectedCity,
  setSelectedCity,
}) => {
  const countryCode =
    selectedCountry && typeof selectedCountry === "object"
      ? selectedCountry.value
      : selectedCountry;

  const stateCode =
    selectedState && typeof selectedState === "object"
      ? selectedState.value
      : selectedState;

  const cityOptions =
    countryCode && stateCode
      ? City.getCitiesOfState(countryCode, stateCode).map((ct) => ({
          value: ct.name,
          label: ct.name,
        }))
      : [];

  return (
    <div className="form-group">
      <label htmlFor="signup-city" className="form-label">
        City
      </label>
      <Select
        id="signup-city"
        options={cityOptions}
        value={selectedCity}
        onChange={(selected) => setSelectedCity(selected)}
        isSearchable
        placeholder="Select City"
        styles={{
          indicatorSeparator: () => ({ display: "none" }),
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? "black" : "#ccc",
            boxShadow: "none",
            fontFamily: '"Rajdhani", sans-serif',
            fontWeight: 600,
            fontSize: "16px",
            "&:hover": { borderColor: "black" },
          }),
          option: (base) => ({
            ...base,
            fontWeight: 600,
            fontSize: "16px",
            fontFamily: '"Rajdhani", sans-serif',
            "&:hover": { backgroundColor: "var(--color-orange)", color: "var(--color-white)" },
          }),
        }}
      />
    </div>
  );
};

export default CityDropdown;
